import { Box, Container, Typography } from "@mui/material";
import { getTranslation } from "common";
import { useTranslations } from "hooks";
import { useEffect } from "react";

export default function LandingPageClaim({ lang }: { lang?: string }) {
    const translations = useTranslations();
    useEffect(() => {
        if (lang) {
            // console.log("LandingPageClaim lang:", lang);
        }
    }, [lang]);

    return (<Container maxWidth="md">
        <Box sx={{ textAlign: 'center', mt: 10, mb: 10 }}>
            <Typography
                variant="h2"
                component="h1"
                sx={{
                    fontWeight: 'bold',
                    color: 'text.primary',
                    mb: 3,
                    fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' }
                }}
            >
                {getTranslation(translations, "landingpage.claim")}
            </Typography>
            <Typography
                variant="h6"
                component="p"
                sx={{
                    color: 'text.secondary',
                    lineHeight: 1.6,
                    fontSize: { xs: '1rem', sm: '1.1rem', md: '1.25rem' }
                }}
            >
                {getTranslation(translations, "landingpage.claim_subtitle")}
            </Typography>
        </Box>
    </Container>)
}
